/**
 * Summary section for a bulk RMA action request: meta and outcome counts.
 */
import { observer } from 'mobx-react-lite';

import DateTimeV2, { DATETIME_VIEW } from '../../../../../../components/datetime-v2/datetime-v2';
import { useDateTimeFormattingParams } from '../../../../../../hooks/use-datetime-formatting-params';
import bulkRmaActionRequestDetailStore from '../../stores/bulk-rma-action-request-detail-store';
import { ACTION_TYPE_LABELS } from '../../utils/bulk-rma-action-labels';
import CountsGrid from './counts-grid';

const RequestSummarySection: React.FC = observer(() => {
    const dateTimeParams = useDateTimeFormattingParams();
    const { detail } = bulkRmaActionRequestDetailStore;

    if (!detail) {
        return null;
    }

    return (
        <div className="bulk-rma-actions-page__detail-section">
                <h5>Summary</h5>
            <div className="bulk-rma-actions-page__meta">
                <span>
                    <strong>Action:</strong>{' '}
                    {ACTION_TYPE_LABELS[detail.action] ?? detail.action}
                </span>
                <span><strong>Chunk size:</strong> {detail.chunk_size}</span>
                <span>
                    <strong>Created:</strong>{' '}
                    {detail.created_at
                        ? (
                            <DateTimeV2
                                {...dateTimeParams}
                                utcDateString={detail.created_at}
                                dateTimeView={DATETIME_VIEW.FULL}
                            />
                        )
                        : '—'}
                </span>
                <span>
                    <strong>Last progress:</strong>{' '}
                    {detail.last_progress_at
                        ? (
                            <DateTimeV2
                                {...dateTimeParams}
                                utcDateString={detail.last_progress_at}
                                dateTimeView={DATETIME_VIEW.FULL}
                            />
                        )
                        : '—'}
                </span>
                <span>
                    <strong>Finished:</strong>{' '}
                    {detail.finished_at
                        ? (
                            <DateTimeV2
                                {...dateTimeParams}
                                utcDateString={detail.finished_at}
                                dateTimeView={DATETIME_VIEW.FULL}
                            />
                        )
                        : '—'}
                </span>
                {detail.created_by_admin_id != null && (
                    <span><strong>Started by admin:</strong> {detail.created_by_admin_id}</span>
                )}
                {detail.cancel_requested && (
                    <span><strong>Cancellation requested:</strong> Yes</span>
                )}
                {detail.cancel_requested_by_admin_id != null && (
                    <span>
                        <strong>Cancelled by admin:</strong> {detail.cancel_requested_by_admin_id}
                    </span>
                )}
            </div>
            <CountsGrid counts={detail.counts} />
        </div>
    );
});

export default RequestSummarySection;
